const GrowthBookCustomProvider = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export default GrowthBookCustomProvider;
